import { render, staticRenderFns } from "./CustomQuestionsTemplates.vue?vue&type=template&id=d24fb8a6&scoped=true"
import script from "./CustomQuestionsTemplates.vue?vue&type=script&lang=js"
export * from "./CustomQuestionsTemplates.vue?vue&type=script&lang=js"
import style0 from "./CustomQuestionsTemplates.vue?vue&type=style&index=0&id=d24fb8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24fb8a6",
  null
  
)

export default component.exports